<template>
  <div class="custom-input location-autocomplete select">
    <fa v-if="faClass" :fa-class="faClass" />

    <div class="input-inner">
      <div v-if="label" :class="getLabelClass">
        {{ $t(label) }}
      </div>

      <multiselect
        :placeholder="$t(placeholder)"
        name="destination"
        ref="destination"
        v-model="search"
        :options="locationItems"
        :multiple="false"
        :searchable="true"
        :loading="isFetching"
        :internal-search="false"
        :close-on-select="true"
        :show-no-results="false"
        open-direction="bottom"
        @search-change="onChangeLocation"
        @select="onSelectLocation"
        :custom-label="customLabel"
        :preserve-search="true"
        :clear-on-select="false"
        deselect-label=""
        select-label=""
      >
        <template slot="singleLabel" slot-scope="props">
          <span class="option__desc">
            <span class="option__title">
              {{ props.option.locationName }}
            </span>
          </span>
        </template>

        <template slot="option" slot-scope="props">
          <div class="option__desc">
            <span class="option__title">
              {{ props.option.locationName }}
            </span>

            <small v-if="props.option.locationType !== 'unknown'">
              <br/>
              {{ $t(props.option.locationType) }}
            </small>
          </div>
        </template>

        <template slot="noOptions">
          {{ $t('_empty_list') }}
        </template>
      </multiselect>

      <span class="positioning">
        <button v-if="search && deselect && !isFetching"
                class="btn orange-white" @click="reset"
        >
          <i class="fas fa-times"></i>
        </button>
      </span>

      <error v-if="displayError">
        {{ errorMessage }}
      </error>
    </div>
  </div>
</template>

<script>
import CommonApi from '@/api/commonApi'
import { cancelAxiosRequest } from '@/utils/apiUtils'
import fa from '@/components/global/icon/fontAwesome'
import formMethods from '@/components/frontoffice/mixins/formMethods'
import error from '@/components/frontoffice/form/error'

export default {
  name: 'locationAutocomplete',

  components: {
    fa,
    error
  },

  mixins: [formMethods],

  props: {
    value: {
      type: [Object, Number, String]
    },
    label: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    faClass: {
      type: String,
      default: 'map-marker'
    },
    required: {
      type: Boolean,
      default: true
    },
    isUnlogged: {
      type: Boolean,
      default: true
    },
    deselect: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      commonApi: new CommonApi(),
      locationItems: [],
      isFetching: false,
      displayError: false,
      errorMessage: '',
      search: this.value,
      searchText: ''
    }
  },

  methods: {
    reset (a) {
      this.search = null
      this.$refs.destination.search = ''
    },

    customLabel ({ locationName }) {
      return `${locationName}`
    },

    onChangeLocation (search) {
      this.searchText = search
      // si requetes déjà en cours, on annule
      cancelAxiosRequest()

      // mini 3 caractères
      if (search.length < 3) {
        this.locationItems = []
        return
      }

      // Get hrs locations
      this.isFetching = true

      this.commonApi.searchLocation(search, !this.isUnlogged)
        .then((response) => {
        this.locationItems = response.data
        //this.locationItems = [];
        //response.data.forEach((item) => this.locationItems.push(item))
        this.isFetching = false
      }).catch(function (error) {
        // errors already catched by axios interceptor => @/views/frontoffice/home.vue
        //this.locationItems = []
        //this.isFetching = false
      })
    },

    onSelectLocation (search) {
      this.search = search
    }
  },

  watch: {
    search (newVal) {
      this.$emit('input', newVal)
    }
  }
}
</script>
